import { render } from "./GestaoDeIaView.vue?vue&type=template&id=0cf96e13&scoped=true"
import script from "./GestaoDeIaView.vue?vue&type=script&lang=js"
export * from "./GestaoDeIaView.vue?vue&type=script&lang=js"

import "./GestaoDeIaView.vue?vue&type=style&index=0&id=0cf96e13&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cf96e13"]])

export default __exports__